export default "__VITE_ASSET__ci3ApSHy__"